module.exports = __webpack_public_path__ + "img/removePanlist.37989069.svg";